(function () {
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      var url = this.dataset.url;
      if (!url) return;

      fetch(url)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var innerSection = doc.querySelector('custom-you-may-also-like');
          if (innerSection && innerSection.innerHTML.trim().length) {
            this.innerHTML = innerSection.innerHTML;
            /* Scripts injected via innerHTML never execute on their own —
               re-fire the same event custom-product-card.js listens for
               so quick-add, swatches, and the gallery all initialize. */
            this.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
          } else {
            this.remove();
          }
        }.bind(this))
        .catch(function () {
          this.remove();
        }.bind(this));
    }
  }

  if (!customElements.get('custom-you-may-also-like')) {
    customElements.define('custom-you-may-also-like', ProductRecommendations);
  }
})();